import React from 'react';
import styled from 'styled-components';
import { TextInput } from 'vendor-deprecated/TextInput';
import { HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { useTranslationText } from 'locale';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { AppColors } from 'helpers';
import { TextDisplay } from 'vendor-deprecated/Text';
import { useAppSetting } from 'helpers/useAppSetting';
import { useHistory } from 'react-router';
import { Button } from 'vendor-deprecated/Button';
import { SimpleSelect, SelectItem } from 'vendor-deprecated/Select';
import { Hr } from 'vendor-deprecated/CommonParts';

interface NewsSearchbarProps {
  maxWidth?: string;
  height?: number;
  category?: string;
  keyword?: string;
  hideTitle?: boolean;
  showAdventure?: boolean;
  roundedSearchBar?: boolean;
}

export const NewsSearchBar = (props: NewsSearchbarProps) => {
  const { appSize } = useAppSetting();
  const history = useHistory();
  const { translation, getTypes } = useTranslationText();

  const [keyword, setKeyword] = React.useState('');
  const [category, setCategory] = React.useState('');
  const [isSearching, setSearching] = React.useState(false);

  const newsTypes = getTypes<SelectItem[]>('articleCategories');

  React.useEffect(() => {
    props.keyword && setKeyword(props.keyword);
    setSearching(false);
  }, [props.keyword]);

  React.useEffect(() => {
    props.category && setCategory(props.category);
  }, [props.category]);

  const isEnableSearch = () => {
    return keyword.length > 0 && keyword.replace(/ /g, '').length > 0;
  };

  const handleSearch = (category: string) => {
    let seoname = '';
    if (keyword !== '') {
      seoname += `keyword=${keyword}`;
    }
    if (category !== '') {
      seoname += `${seoname != '' ? '&' : ''}category=${category}`;
    }

    history.push(`/articles/search/?${seoname}`);
  };

  return (
    <VerticalView width={props.roundedSearchBar ? '90%' : '100%'} alignContent={'centerLeft'} position={'relative'}>
      {!props.hideTitle && (
        <TextDisplay size={appSize.h2} fontWeight={600}>
          {translation('search')}
        </TextDisplay>
      )}

      <HorizontalView fullWidth position={'relative'} borderRadius={'4px'} overflow={'hidden'}>
        <TextInput
          placeholder={translation('keyword')}
          value={keyword}
          paddingLeft={'20px'}
          paddingRight={'40px'}
          width={'100%'}
          height={props.height ? `${props.height}px` : '50px'}
          borderRadius={props.roundedSearchBar ? (props.height ? `${props.height / 2}px` : '25px') : '4px'}
          border={'1px solid #cccccc'}
          fontSize={'14px'}
          onChange={(e) => {
            setSearching(false);
            setKeyword(e.target.value);
          }}
          onPressEnter={() => {
            handleSearch(category);
          }}
        />
        <HorizontalView position={'absolute'} top={'0'} right={'0'} bottom={'0'} width={'60px'}>
          {!props.roundedSearchBar && (
            <Button
              disabled={!isEnableSearch()}
              width={'60px'}
              height={'100%'}
              icon={'search'}
              size={'25px'}
              color={'white'}
              background={AppColors.AUTHOR_HEADER}
              isLoading={isSearching}
              onClick={() => {
                // setSearching(true)
                handleSearch(category);
              }}
            />
          )}
          {props.roundedSearchBar && <SVGIcon size={'25px'} name={'search'} color={AppColors.GRAY_LIGHT} />}
        </HorizontalView>
      </HorizontalView>
      {props.showAdventure && (
        <VerticalView fullWidth alignContent={'centerLeft'} paddingTop={'20px'} paddingBottom={'10px'}>
          <SimpleSelect
            width={'250px'}
            height={'50px'}
            marginBottom={'20px'}
            size={appSize.md}
            direction={'column'}
            text={translation(`post.category`)}
            value={category}
            options={newsTypes}
            onChange={(category) => {
              handleSearch(category);
            }}
          />
          <Hr />
        </VerticalView>
      )}
    </VerticalView>
  );
};
